module.exports = __webpack_public_path__ + "img/cart_icon.0b164d45.svg";